import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { getAssetPreloadingUtil } from '../../../../main/utils/asset/asset-preloading.util.ts';

import { LESSON_SLICE_NAME } from '../lesson.slice.types.ts';

interface Props {
  lessonKey: number;
}

const THUNK_NAME = `${LESSON_SLICE_NAME}/preloadLessonPicturesThunk`;

export const preloadLessonAssetsThunk = createAsyncThunk<void, Props, ThunkApiConfigType>(
  THUNK_NAME,
  async (props, _): Promise<void> => {
    const { lessonKey } = props;

    await getAssetPreloadingUtil().preloadLessonAssets({ lesson: lessonKey });
  }
);
